import { compose } from 'ramda';

import { toNotFound, redirectTo } from '../../../store/location/actions';
import { selectParams } from '../../../store/location/selectors';
import { gameUrl } from '../../url-builders';
import { appendParams } from '../../url-builders/url-utils';

export const path = '/game';

export const component = 'Loading';

export const thunk = () => (dispatch, getState) => {
  const state = getState();
  const { product, gameId, ...otherParams } = selectParams(state);
  if (!product || !gameId) dispatch(toNotFound());

  compose(
    dispatch,
    redirectTo,
    appendParams(otherParams),
    gameUrl
  )({ gameId, product });
};
